export const elementNames = {
    continue: 'continue',
    email: 'email',
};

export const errorNames = {
    emailError: 'emailError',
    submitError: 'submitError',
};

export const elementMetricNames = {
    [elementNames.continue]: 'Continue button',
    [elementNames.email]: 'Email',
};

export const componentNames = {
    [elementNames.continue]: 'Continue button',
    [elementNames.email]: 'Email',
};

export const EMAIL_TAKEN_MESSAGE = 'That email is already in use.';
export const EMAIL_VALIDATION_RESULT = {
    USED: 'USED',
    UNUSED: 'UNUSED',
    UNKNOWN: 'UNKNOWN',
};
